<nav class="mb-3 flex items-center gap-2 text-sm" style="color: var(--muted-foreground)">
  @for (item of items; track item.label; let last = $last) {
    @if (!last) {
      @if (item.routerLink) {
        <a [routerLink]="item.routerLink" class="no-underline transition-colors hover:underline" style="color: var(--muted-foreground)">{{ item.label }}</a>
      } @else {
        <span>{{ item.label }}</span>
      }
      <i class="pi pi-angle-right text-xs"></i>
    } @else {
      <span style="color: var(--foreground)">{{ item.label }}</span>
    }
  }
</nav>
